import { render, staticRenderFns } from "./Tariffbox.vue?vue&type=template&id=4cd25544&scoped=true&"
import script from "./Tariffbox.vue?vue&type=script&lang=js&"
export * from "./Tariffbox.vue?vue&type=script&lang=js&"
import style0 from "./Tariffbox.vue?vue&type=style&index=0&id=4cd25544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd25544",
  null
  
)

export default component.exports